export default __webpack_public_path__ + "static/media/family_avatar_1.f6d677b5.svg";